import { type CSSProperties, type ReactNode } from 'react';

import { type RequestContext } from '~/types/RequestContext';

import { BettingInsightsComponent } from '../BettingInsightsConfiguration';
import { type BettingInsightsContent, type EsIndex } from '../types';

export interface BettingInsightsTableHeadingConfig<TIndex extends EsIndex> {
	className?: string;
	highlight?: boolean;
	isMain?: boolean;
	justifyContent?: CSSProperties['justifyContent'];
	key: string;
	mobileView?: 'hide';
	render: (
		this: BettingInsightsTableHeading<TIndex>,
		data: { content: BettingInsightsContent<TIndex>; resultIndex: number },
	) => ReactNode;
	renderMobile?: (
		this: BettingInsightsTableHeading<TIndex>,
		data: { content: BettingInsightsContent<TIndex>; resultIndex: number },
	) => ReactNode;
	shouldRenderMobile?: boolean;
	shouldShowIndicator?: boolean;
	tooltipPosition?: 'top' | 'bottom' | 'left' | 'right';
	tooltipText?: string;
}

export class BettingInsightsTableHeading<TIndex extends EsIndex>
	extends BettingInsightsComponent
	implements BettingInsightsTableHeadingConfig<TIndex>
{
	highlight?: boolean;
	isMain: boolean;
	className?: string;
	justifyContent?: CSSProperties['justifyContent'];
	key: string;
	mobileView?: 'hide';
	render: (
		this: BettingInsightsTableHeading<TIndex>,
		data: { content: BettingInsightsContent<TIndex>; resultIndex: number },
	) => ReactNode;
	renderMobile?: (
		this: BettingInsightsTableHeading<TIndex>,
		data: { content: BettingInsightsContent<TIndex>; resultIndex: number },
	) => ReactNode;
	shouldRenderMobile: boolean;
	shouldShowIndicator: boolean;
	tooltipPosition?: 'top' | 'bottom' | 'left' | 'right';
	tooltipText?: string;

	constructor({
		className,
		highlight,
		isMain,
		justifyContent,
		key,
		mobileView,
		render,
		renderMobile,
		shouldRenderMobile,
		shouldShowIndicator,
		tooltipPosition,
		tooltipText,
		...requestContext
	}: BettingInsightsTableHeadingConfig<TIndex> & RequestContext) {
		super(requestContext);
		this.highlight = highlight ?? false;
		this.isMain = isMain ?? false;
		this.className = className ?? '';
		this.justifyContent = justifyContent;
		this.key = key;
		this.mobileView = mobileView;
		this.render = render.bind(this);
		this.renderMobile = renderMobile?.bind(this);
		this.shouldRenderMobile = shouldRenderMobile ?? false;
		this.shouldShowIndicator = shouldShowIndicator ?? false;
		this.tooltipPosition = tooltipPosition;
		this.tooltipText = tooltipText;
	}

	static withRequestContext<TIndex extends EsIndex>(
		requestContext: RequestContext,
		config: BettingInsightsTableHeadingConfig<TIndex>,
	) {
		return new this<TIndex>({
			...requestContext,
			...config,
		});
	}
}
